/* ============================================================
   Mega menu — desktop hover (with close delay) + keyboard
   (focus opens, Esc closes, aria-expanded), and mobile drawer.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-mega-trigger]'));
    var panels = {};
    header.querySelectorAll('[data-mega-panel]').forEach(function (p) {
      panels[p.getAttribute('data-mega-panel')] = p;
    });
    var hideTimer;

    function openMega(key) {
      clearTimeout(hideTimer);
      Object.keys(panels).forEach(function (k) {
        var open = k === key;
        panels[k].classList.toggle('open', open);
      });
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', t.getAttribute('data-mega-trigger') === key ? 'true' : 'false');
      });
    }
    function closeMega(delay) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        Object.keys(panels).forEach(function (k) { panels[k].classList.remove('open'); });
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }, delay == null ? 140 : delay);
    }

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-mega-trigger');
      t.addEventListener('mouseenter', function () { openMega(key); });
      t.addEventListener('mouseleave', function () { closeMega(); });
      t.addEventListener('focus', function () { openMega(key); });
    });
    Object.keys(panels).forEach(function (k) {
      panels[k].addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
      panels[k].addEventListener('mouseleave', function () { closeMega(); });
    });

    // Esc closes; close when focus leaves the header entirely
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMega(0); if (document.activeElement) document.activeElement.blur(); }
    });
    document.addEventListener('focusin', function (e) {
      if (!header.contains(e.target)) closeMega(0);
    });

    // ---------- mobile drawer ----------
    var drawer = document.querySelector('[data-drawer]');
    var openBtn = header.querySelector('[data-drawer-open]');
    function setDrawer(open) {
      if (!drawer) return;
      drawer.hidden = !open;
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer || e.target.closest('[data-drawer-close]')) setDrawer(false);
        var toggle = e.target.closest('[data-acc-toggle]');
        if (toggle) {
          var acc = toggle.closest('.acc');
          var open = acc.classList.toggle('open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden) setDrawer(false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
